var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPurchasingCalculator(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 1)",
    stroke: "#9C9DA1",
    strokeWidth: 1.5,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0l2.273 2.727v8.182L.909 15.091H20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.273 2.727h15.909l-2.727 8.182H2.273"
  }), /*#__PURE__*/React.createElement("circle", {
    strokeLinecap: "square",
    cx: 2.727,
    cy: 18.182,
    r: 1.818
  }), /*#__PURE__*/React.createElement("circle", {
    strokeLinecap: "square",
    cx: 17.273,
    cy: 18.182,
    r: 1.818
  }))));
}
export default SvgIconPurchasingCalculator;